import type { TripView } from '@voll-intelligence/domain';
import { cityLabel } from './format.js';

/**
 * O NOME da viagem, a regra única de toda superfície (capa do PDF, sidebar, painel,
 * menções): o que o viajante escreveu vence de tudo, para sempre; sem ele, a CIDADE do
 * destino em qualquer forma que a fonte mande ("SAO", "GRU - SAO PAULO", "São Paulo");
 * sem destino, a cidade da origem. `null` quando não há nada — quem chama aplica o
 * fallback da própria tela ("Sua viagem" no documento, "Viagem em andamento" no shell).
 *
 * A janela de datas NÃO entra aqui de propósito: toda superfície que precisa dela a
 * mostra ao lado, uma vez, e o nome não pode repeti-la.
 */
export function tripDisplayName(
  trip: Pick<TripView, 'origin' | 'destination' | 'manualName'>,
): string | null {
  const manual = trip.manualName?.trim();
  if (manual) return manual;
  return cityLabel(trip.destination) || cityLabel(trip.origin) || null;
}
